import { Stack } from "@mantine/core"
import { SectionHeader } from "@tfg/ui"
import { useState } from "react"
import { useTranslation } from "react-i18next"

import { InlineBanner, InlineBannerProps } from "~/components/InlineBanner.tsx"
import { MaterialMappingWrapper } from "~/pages/Admin/Mapping/Materials"
import { ProductMappingWrapper } from "~/pages/Admin/Mapping/Product"
import { StandardMappingWrapper } from "~/pages/Admin/Mapping/Standards"
import { MappingTypeNames } from "~/pages/Admin/Mapping/types"

export function Mapping({ count }: { count: number }) {
  const { t } = useTranslation("organizationSettings")

  const [activeMapping, setActiveMapping] = useState<MappingTypeNames | null>(
    MappingTypeNames.PRODUCT
  )

  const bannerConfig: InlineBannerProps = {
    type: count > 0 ? "error" : "success",
    message: count > 0 ? t("mapping.pending", { count }) : t("mapping.success"),
  }
  return (
    <>
      <SectionHeader
        title={t("mapping.title")}
        subtitle={t("mapping.pageDescription")}
      />
      <Stack>
        <InlineBanner {...bannerConfig} />
        <ProductMappingWrapper
          isOpen={activeMapping === MappingTypeNames.PRODUCT}
          close={() => {
            setActiveMapping(null)
          }}
          open={() => {
            setActiveMapping(MappingTypeNames.PRODUCT)
          }}
        />
        <MaterialMappingWrapper
          isOpen={activeMapping === MappingTypeNames.MATERIAL}
          close={() => setActiveMapping(null)}
          open={() => {
            setActiveMapping(MappingTypeNames.MATERIAL)
          }}
        />
        <StandardMappingWrapper
          isOpen={activeMapping === MappingTypeNames.STANDARD}
          close={() => {
            setActiveMapping(null)
          }}
          open={() => {
            setActiveMapping(MappingTypeNames.STANDARD)
          }}
        />
      </Stack>
    </>
  )
}
